// extracted by mini-css-extract-plugin
export default {"radio":"togJg24J"};